<template>
  <div class="personal-information-cmp" @click="hiddenLanguageOptions">
    <switch-i18n ref="i18nRef" />
    <div class="article-wrapper">
      <h1>{{ appName }}{{ $t('common.personalInformationTitle') }}</h1>
      <slot name="app-desc"></slot>
      <p>{{ $t('common.personalInformation01') }}</p>
      <table>
        <tr>
          <th>{{ $t('common.personalInformationTable01') }}</th>
          <th>{{ $t('common.personalInformationTable02') }}</th>
          <th>{{ $t('common.personalInformationTable03') }}</th>
        </tr>
        <tr>
          <td rowspan="6">{{ $t('common.personalInformationTable04') }}</td>
          <td>{{ $t('common.personalInformationTable05') }}</td>
          <td rowspan="3">{{ $t('common.personalInformationTable08') }}</td>
        </tr>
        <tr>
          <td>{{ $t('common.personalInformationTable06') }}</td>
        </tr>
        <tr>
          <td>{{ $t('common.personalInformationTable07') }}</td>
        </tr>
        <tr>
          <td>{{ $t('common.personalInformationTable09') }}</td>
          <td rowspan="3">{{ $t('common.personalInformationTable12') }}</td>
        </tr>
        <tr>
          <td>{{ $t('common.personalInformationTable10') }}</td>
        </tr>
        <tr>
          <td>{{ $t('common.personalInformationTable11') }}</td>
        </tr>
        <tr>
          <td>{{ $t('common.personalInformationTable13') }}</td>
          <td>{{ $t('common.personalInformationTable14') }}</td>
          <td>{{ $t('common.personalInformationTable15') }}</td>
        </tr>
        <tr>
          <td rowspan="13">{{ $t('common.personalInformationTable16') }}</td>
          <td>{{ $t('common.personalInformationTable17') }}</td>
          <td rowspan="13">{{ $t('common.personalInformationTable30') }}</td>
        </tr>
        <tr>
          <td>{{ $t('common.personalInformationTable18') }}</td>
        </tr>
        <tr>
          <td>{{ $t('common.personalInformationTable19') }}</td>
        </tr>
        <tr>
          <td>{{ $t('common.personalInformationTable20') }}</td>
        </tr>
        <tr>
          <td>{{ $t('common.personalInformationTable21') }}</td>
        </tr>
        <tr>
          <td>{{ $t('common.personalInformationTable22') }}</td>
        </tr>
        <tr>
          <td>{{ $t('common.personalInformationTable23') }}</td>
        </tr>
        <tr>
          <td>{{ $t('common.personalInformationTable24') }}</td>
        </tr>
        <tr>
          <td>{{ $t('common.personalInformationTable25') }}</td>
        </tr>
        <tr>
          <td>{{ $t('common.personalInformationTable26') }}</td>
        </tr>
        <tr>
          <td>{{ $t('common.personalInformationTable27') }}</td>
        </tr>
        <tr>
          <td>{{ $t('common.personalInformationTable28') }}</td>
        </tr>
        <tr>
          <td>{{ $t('common.personalInformationTable29') }}</td>
        </tr>
      </table>
      <p>{{ $t('common.personalInformation02') }}<a href="./privacy.html" target="_blank">{{ $t('common.personalInformation03') }}</a>{{ $t('common.personalInformation04') }}</p>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import { useTitle } from '@/hooks/useTitle'
import { useHideLanguageOptions } from '@/hooks/useHideLanguageOptions';
import SwitchI18n from "@/components/switch_i18n.vue"

// 定义属性
defineProps({
  appName: {
    type: String,
    default: '',
  },
});

// 监听到语言发生改变后修改标题
useTitle('common.personalInformationTitle');

// 点击空白区域隐藏语言选择框
const { i18nRef, hiddenLanguageOptions } = useHideLanguageOptions();
</script>

<style lang="less">
</style>
